import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Card, TableRow } from '@mui/material';
import TablePagination from '@mui/material/TablePagination';
import TableCell from 'src/components/Table/TableCell';
import { useTranslation } from 'react-i18next';
import TablePaginationCustom from 'src/components/Table/TablePaginationCustom';
import Table from 'src/components/Table';
import NotFoundRecords from 'src/components/NotFoundRecords';
import SantanderClabesRow from './SantanderClabesRow';

if (!process.env.REACT_APP_TABLE_SIZE) {
  console.error(
    'REACT_APP_TABLE_SIZE variable not loaded properly. Check your .env file please!'
  );
}

const Tbody = ({ clabes }) =>
  clabes.map(clabe => <SantanderClabesRow key={clabe.clabe} {...clabe} />);

const SantanderClabesTable = ({
  clabes,
  loading,
  success,
  count,
  page,
  handleChangePage,
  ...rest
}) => {
  const { t } = useTranslation();

  const theads = useMemo(() => () => (
    <TableRow component="tr">
      <TableCell variant="head" align="center" key="clabe">
        {t('ADMINISTRATOR_VIEW.SANTANDER_CLABES.CLABE_NUMBER')}
      </TableCell>
      <TableCell variant="head" align="center" key="client">
        {t('ADMINISTRATOR_VIEW.SANTANDER_CLABES.ASSIGNED_CLIENT')}
      </TableCell>
      <TableCell sx={{ width: '20%' }} variant="head" key="actions" />
    </TableRow>
  ));

  const tbody = useMemo(() => () => <Tbody clabes={clabes} />, [clabes]);

  const pagination = useMemo(
    () => () => (
      <TablePagination
        rowsPerPageOptions={[]}
        component="div"
        count={count}
        rowsPerPage={+process.env.REACT_APP_TABLE_SIZE}
        page={page}
        onPageChange={handleChangePage}
        ActionsComponent={TablePaginationCustom}
        labelDisplayedRows={({ from, to, count: c }) => {
          return `${from}-${to} ${t('COMMON.OF')} ${c}`;
        }}
      />
    ),
    [page, count, t]
  );

  if (success && !loading && !clabes.length) {
    return (
      <Card>
        <NotFoundRecords title="NOT_FOUND_RECORDS_MESSAGE.SANTANDER_CLABES_TITLE" />
      </Card>
    );
  }

  return (
    <Table
      {...rest}
      tbody={tbody}
      theads={theads}
      loading={loading}
      pagination={pagination}
    />
  );
};

SantanderClabesTable.propTypes = {
  clabes: PropTypes.array.isRequired,
  loading: PropTypes.bool.isRequired,
  success: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  handleChangePage: PropTypes.func.isRequired
};

export default SantanderClabesTable;
